<!--“异常反馈”和“功能建议”-->
<!--type=bugs为异常反馈-->
<!--type=idea为功能建议-->
<template>
  <div class="complaint-form">
    <complaint-section label="问题类型">
      <radio-button-group
        ref="radioButtonGroup"
        :buttonEnum="questionTypes"
        @on-change="handleTypeChange"
      ></radio-button-group>
    </complaint-section>
    <complaint-section :label="isBug ? bugsPageConfig.label : suggestPageConfig.label">
      <z-field
          darkBg
          v-model="msgTxt"
          type="textarea"
          :placeholder="isBug ? bugsPageConfig.placeholder : suggestPageConfig.placeholder"
          rows="3"
          :maxlength="500"
          count-word
        >
        </z-field>
      <div class="complaint-textarea-upload-area">
        <z-upload
          v-model="files"
          ref="upload"
          :process-file="processFile"
          :accept="accept"
          :max="max"
          :zzapp="zzapp"
        >
        </z-upload>
      </div>
    </complaint-section>
    <z-radio-group
      v-model="checkUploadLog"
      v-if="pageType == 'bugs' && !isOpenHarmony">
      <z-radio
        class="upload-log"
        :onClickItemHook="clickUploadLog"
        :name="1"
      >
        上传本地日志（预计耗时30秒）
      </z-radio>
    </z-radio-group>
    <z-button-group>
      <z-button @click="confirmSubmit" :disabled="!canSubmit" type="primary">提交</z-button>
    </z-button-group>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Upload, Button, ButtonGroup, Toast, RadioGroup, Radio, Field } from '@zz-common/zz-ui'
import { env } from '@zz-common/zz-utils'
import compress from '@zz-common/zz-ui/lib/utils/image'
import { adduseradvice, getuseradviceconf } from '../../api/resourceApi'
import { getCookie, queryParams } from '../../lib/utils'

import ComplaintSection from './components/complaint-section'
import RadioButtonGroup from './components/radio-button-group'

const MAX_INPUT_NUM = 500
const query = queryParams()

export default {
  name: 'ComplaintForm',
  components: {
    ComplaintSection,
    RadioButtonGroup,
    'z-button-group': ButtonGroup,
    'z-button': Button,
    'z-upload': Upload,
    'z-radio': Radio,
    'z-radio-group': RadioGroup,
    'z-field': Field
  },
  data() {
    return {
      checkUploadLog: 1,
      pageType: query.type,
      isBug: query.type == 'bugs',
      questionTypes: [],
      selectedQuestionType: '',
      msgTxt: '',
      maxNum: MAX_INPUT_NUM,
      // action: { target: 'https://upload.58cdn.com.cn/json?rand=0.1928', zz: true },
      accept: 'image/*',
      max: 9,
      zzapp: true,
      files: [],
      contact: '',
      orderId: '',
      fetching: false,
      showProgress: false,
      submitFlag: 0,
      log: '',
      progressNum: '0',
      bugsPageConfig: {
        title: '功能异常',
        label: '异常反馈',
        placeholder: '请具体描述使用转转所遇到的功能异常（如白屏/卡顿/闪退等问题）'
      },
      suggestPageConfig: {
        title: '使用建议',
        label: '产品建议',
        placeholder: '请描述转转APP产品使用体验或意见'
      }
    }
  },
  async created() {
    native.setTitle({
      title: this.isBug ? this.bugsPageConfig.title : this.suggestPageConfig.title
    })
    await this.getuseradviceconf()
    this.$refs.radioButtonGroup.init()
  },
  computed: {
    isOpenHarmony() { // 是否为鸿蒙
      return env.$isOpenHarmony
    },
    canSubmit() {
      return this.selectedQuestionType !== '' && this.msgTxt !== ''
    }
  },
  methods: {
    processFile(file, next) {
      compress(
        file,
        {
          compress: true // 开启图片压缩，提高上传的速度，同时修正拍摄的图片方向和显示的问题
        },
        next
      )
    },
    handleTypeChange(result) {
      const { questionType } = result[0]
      this.selectedQuestionType = questionType
    },
    txtBoxBlur() {
      setTimeout(() => {
        window.scrollTo(0, window.pageYOffset)
      }, 100)
    },
    updateTextInfo() {
      const elem = this.$refs.textInput
      elem.style.height = 'auto'
      elem.style.height = elem.scrollHeight + 'px'
      elem.scrollTop = elem.scrollHeight
      if (this.msgTxt.length > MAX_INPUT_NUM) {
        this.msgTxt = this.msgTxt.substring(0, MAX_INPUT_NUM)
      }
    },
    confirmSubmit() {
      if (this.msgTxt.length < 10) {
        Toast('至少输入10个字描述您的问题')
        return
      }
      const fileUrl = this.files.map((item) => {
        const name = item.url.split('zhuanzh/')[1]
        return name
      })
      const params = {
        classify: 'others',
        imgs: fileUrl.join('|'),
        type: query.type == 'bugs' ? 1 : 2,
        navigator: `${getCookie('model')},${getCookie('v')}`,
        log: '',
        tel: this.contact || getCookie('tel'),
        uid: getCookie('uid'),
        complainCenter: '1', // 标识客服侧使用的投诉
        contents: `${this.msgTxt}`,
        questiontype: Number(this.selectedQuestionType)
      }
      this.submit(params)
    },
    async getuseradviceconf() {
      const res = await getuseradviceconf({
        sourcetype: 1
      })
      if (!res) return
      this.questionTypes = res.questionTypeBeans
    },
    async submitFormData(params) {
      if (this.fetching) return
      this.fetching = true
      const res = await adduseradvice(params)
      this.fetching = false
      if (!res) return
      this.$router.push({
        name: 'InterFeedbackSuccess'
      })
    },
    clickUploadLog() {
      if (this.checkUploadLog === 0) {
        this.checkUploadLog = 1
      } else {
        this.checkUploadLog = 0
      }
    },
    submit(data) {
      // 避免重复提交
      switch (this.submitFlag) {
        case 0: // 未提交
          this.submitFlag_0(data)
          break
        case 1: // 已提交-未返回数据
          this.submitFlag_1()
          break
        case 2: // 已提交-已返回数据
          this.submitFlag_2()
          break
        case 3: // 未提交，正在上传日志
          this.submitFlag_3()
          break
      }
    },
    submitFlag_0(data) {
      let timer = null
      // 补充：鸿蒙系统uploadNativeLog不支持，此处屏蔽掉鸿蒙
      if (this.checkUploadLog === 1 && this.pageType == 'bugs' && !this.isOpenHarmony) {
        // 选中上传日志
        this.submitFlag = 3
        this.showProgress = true
        const toast = Toast.loading({
          forbidClick: true,
          message: '提交中',
          duration: 0
        });
        timer = setTimeout(() => {
          toast.clear()
          this.showProgress = false
          this.$router.go(-1)
        }, 60 * 1000)
        // 先上传日志
        native.wrap('uploadNativeLog')((res) => {
          if (res.code === '0') {
            clearTimeout(timer)
            this.log = res.url
            data.log = res.url
            toast.clear()
            this.showProgress = false
            // 日志上传成功后，上传数据
            this.submitData(data)
          } else if (res.code === '1') {
            this.progressNum = Math.floor(res.progress * 100)
          } else if (res.code === '-1') {
            clearTimeout(timer)
            this.submitFlag = 0
            toast.clear()
            this.showProgress = false
            Toast('日志上传失败了,请重试')
          }
        })
      } else {
        // 未选中上传日志，直接上传数据
        this.submitData(data)
      }
    },
    submitFlag_1() {
      Toast('信息提交中，请耐心等待')
    },
    submitFlag_2() {
      Toast('信息已提交成功，请不要重复提交')
    },
    submitFlag_3() {
      Toast('正在上传日志，请稍后')
    },
    async submitData(data) {
      // 校验后后执行
      this.submitFlag = 1
      const res = await adduseradvice(data)
      if (!res) {
        this.submitFlag = 0
        Toast('信息提交失败，请重试！')
        return
      }
      this.submitFlag = 2
      this.$router.push({
        name: 'InterFeedbackSuccess'
      })
      // adduseradvice(data).then((res)=>{
      //   if(res.data.respCode === '0'){
      //     this.submitFlag = 2;
      //     this.adaptorAlert('信息已提交成功，客服人员将尽快联系您');
      //     setTimeout(()=>{
      //       if(this.$route.query.type == 'trust'){
      //         Adapter.wrap('close')();
      //       }else{
      //         this.$router.go(-1);
      //       }
      //     },1000)
      //   }else{
      //     this.submitFlag = 0;
      //     this.adaptorAlert('提交失败，服务器错误');
      //   }
      // },(res)=>{
      //   this.submitFlag = 0;
      //   this.adaptorAlert('提交失败，服务器错误');
      // })
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/base.less';
  .complaint-form {
    padding-bottom: 236px;
    background-color: #fafafa;
  }
  .complaint-textarea {
    padding: 24px;
    margin: 0 24px 24px 24px;
    background-color: #fafafa;
    border-radius: 8px;
    > textarea {
      display: block;
      box-sizing: border-box;
      resize: none;
      width: 100%;
      min-height: 250px;
      max-height: 420px;
      font-size: 30px;
      line-height: 42px;
      word-break: break-all;
      word-wrap: break-word;
      overflow-wrap: break-word;
      text-justify: inter-ideograph;
      text-align: justify;
      text-align-last: left;
      border: none;
      outline: none;
      background-color: #fafafa;
    }
    > textarea::-webkit-input-placeholder {
      color: #999;
    }
    &-num-wrap {
      overflow: hidden;
    }
    &-num {
      float: right;
      color: #999;
      font-size: 24px;
      span.red {
        color: #ff5555;
      }
    }
  }
  .complaint-textarea-upload-area {
    padding: 0 24px 20px 24px;
    .clear-fix {
      overflow: hidden;
    }
    .upload-file {
      width: 108px;
      height: 108px;
    }
    .upload-btn {
      width: 108px;
      height: 108px;
      background: url('../../assets/img/upload_icon.png') no-repeat;
      background-size: 100%;
    }
  }
  .upload-log {
    margin: 30px 30px 30px 30px;
    padding: 0 !important;
    background: none;
    /deep/ .z-radio__label {
      font-family: PingFangSC-Regular;
      font-size: 24px;
      color: #9b9b9b;
    }
    /deep/ .z-icon {
      font-size: 35px;
    }
  }
  .upload-progress-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -100%);
  }
  .spinner {
    margin: 40px auto;
    width: 120px;
    height: 120px;
    position: relative;
  }

  .container1 > div,
  .container2 > div,
  .container3 > div {
    width: 25px;
    height: 25px;
    background-color: #ffffff;

    border-radius: 100%;
    position: absolute;
    -webkit-animation: bouncedelay 1.2s infinite ease-in-out;
    animation: bouncedelay 1.2s infinite ease-in-out;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  .spinner .spinner-container {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .container2 {
    -webkit-transform: rotateZ(45deg);
    transform: rotateZ(45deg);
  }

  .container3 {
    -webkit-transform: rotateZ(90deg);
    transform: rotateZ(90deg);
  }

  .circle1 {
    top: 0;
    left: 0;
  }
  .circle2 {
    top: 0;
    right: 0;
  }
  .circle3 {
    right: 0;
    bottom: 0;
  }
  .circle4 {
    left: 0;
    bottom: 0;
  }

  .container2 .circle1 {
    -webkit-animation-delay: -1.1s;
    animation-delay: -1.1s;
  }

  .container3 .circle1 {
    -webkit-animation-delay: -1s;
    animation-delay: -1s;
  }

  .container1 .circle2 {
    -webkit-animation-delay: -0.9s;
    animation-delay: -0.9s;
  }

  .container2 .circle2 {
    -webkit-animation-delay: -0.8s;
    animation-delay: -0.8s;
  }

  .container3 .circle2 {
    -webkit-animation-delay: -0.7s;
    animation-delay: -0.7s;
  }

  .container1 .circle3 {
    -webkit-animation-delay: -0.6s;
    animation-delay: -0.6s;
  }

  .container2 .circle3 {
    -webkit-animation-delay: -0.5s;
    animation-delay: -0.5s;
  }

  .container3 .circle3 {
    -webkit-animation-delay: -0.4s;
    animation-delay: -0.4s;
  }

  .container1 .circle4 {
    -webkit-animation-delay: -0.3s;
    animation-delay: -0.3s;
  }

  .container2 .circle4 {
    -webkit-animation-delay: -0.2s;
    animation-delay: -0.2s;
  }

  .container3 .circle4 {
    -webkit-animation-delay: -0.1s;
    animation-delay: -0.1s;
  }

  @-webkit-keyframes bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
    }
  }

  @keyframes bouncedelay {
    0%,
    80%,
    100% {
      transform: scale(0);
      -webkit-transform: scale(0);
    }
    40% {
      transform: scale(1);
      -webkit-transform: scale(1);
    }
  }
</style>
